import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	ruleLogicNameText: {
		color: colors.blue[400],
		marginRight: theme.spacing(1)
	},
	ruleLogicNameDivider: {
		flex: 1,
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[100])
	}
}))

export default useStyles
